import {Component, inject, input, OnInit, output} from '@angular/core';
import {TuiAsideComponent, TuiAsideGroupComponent, TuiAsideItemDirective} from "@taiga-ui/layout";
import {TuiChevron} from "@taiga-ui/kit";
import {Location} from '@angular/common';
import {RouterLink} from "@angular/router";
import {INavLink} from "../../@core/interfaces/nav-link.interface";
import {environment} from "../../../environments/environment";
import {CSGOFAST_LINKS, HLTV_LINKS} from "./links.const";

@Component({
  selector: 'app-side-bar',
  imports: [
    TuiAsideComponent,
    TuiAsideGroupComponent,
    TuiAsideItemDirective,
    TuiChevron,
    RouterLink
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  readonly #location = inject(Location);

  public sideBarLinks!: INavLink[];
  public activePath!: string | undefined;


  constructor() {
    this.sideBarLinks = environment.projectName === 'HLTV'
      ? HLTV_LINKS
      : CSGOFAST_LINKS;
  }

  isSidebarCollapsed = input.required<boolean>()
  changeSidebarCollapsed = output<boolean>();

  public toggleSidebar(): void {
    this.changeSidebarCollapsed.emit(!this.isSidebarCollapsed());
  }

  ngOnInit() {
    this.activePath = this.#location.path().split('/')[1];
  }

}
